import { AdminConstants } from "../constants/admin.constants";

const AdminReducer = (state, action) => {
  switch (action.type) {
    case AdminConstants.FETCH_ADMIN_REQUEST:
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case AdminConstants.FETCH_ADMIN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        admins: action.payload.data,
        paging: action.payload.paging,
      };
    case AdminConstants.FETCH_ADMIN_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoading: false,
      };

    case AdminConstants.ADMIN_SEARCH_REQUEST:
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case AdminConstants.ADMIN_SEARCH_SUCCESS:
      return {
        ...state,
        isLoading: false,
        adminSearchResults: action.payload,
      };
    case AdminConstants.ADMIN_SEARCH_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoading: false,
      };

    case AdminConstants.ADMIN_AUTO_SEARCH_REQUEST:
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case AdminConstants.ADMIN_AUTO_SEARCH_SUCCESS:
      return {
        ...state,
        isLoading: false,
        adminAutoSearchResults: action.payload,
      };
    case AdminConstants.ADMIN_AUTO_SEARCH_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoading: false,
      };

    case AdminConstants.ADD_ADMIN_REQUEST:
      return {
        ...state,
        isSubmitting: true,
        hasError: false,
      };
    case AdminConstants.ADD_ADMIN_SUCCESS:
      return {
        ...state,
        isSubmitting: false,
      };
    case AdminConstants.ADD_ADMIN_FAILURE:
      return {
        ...state,
        hasError: true,
        isSubmitting: false,
        errorMessage: action.payload.message,
      };

    case AdminConstants.GET_ADMIN_REQUEST:
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case AdminConstants.GET_ADMIN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        admin: action.payload,
      };
    case AdminConstants.GET_ADMIN_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoading: false,
      };

    case AdminConstants.UPDATE_ADMIN_REQUEST:
      return {
        ...state,
        isSubmitting: true,
        hasError: false,
      };
    case AdminConstants.UPDATE_ADMIN_SUCCESS:
      return {
        ...state,
        isSubmitting: false,
        admin: action.payload,
      };
    case AdminConstants.UPDATE_ADMIN_FAILURE:
      return {
        ...state,
        hasError: true,
        isSubmitting: false,
      };
    case AdminConstants.DOWNLOAD_ADMIN_REQUEST:
      console.log("action33333333", action.payload);
      return {
        ...state,
        isLoadingDownload: true,
        hasError: false,
        downloadFileType: action.payload.fileType,
      };
    case AdminConstants.DOWNLOAD_ADMIN_SUCCESS:
      return {
        ...state,
        isLoadingDownload: false,
        downloadFileType: "",
      };
    case AdminConstants.DOWNLOAD_ADMIN_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoadingDownload: false,
        downloadFileType: "",
      };
    case AdminConstants.UPLOAD_ADMIN_REQUEST:
      return {
        ...state,
        isUpload: true,
        uploadError: false,
      };
    case AdminConstants.UPLOAD_ADMIN_SUCCESS:
      return {
        ...state,
        uploadSuccess: true,
        uploadError: false,
        isUpload: false,
      };
    case AdminConstants.UPLOAD_ADMIN_FAILURE:
      return {
        ...state,
        uploadError: true,
        isUpload: false,
      };

    default:
      return state;
  }
};

export default AdminReducer;
